import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'
import NoResults from '../serp/NoResults'
import Products from '../serp/Products'
import Toolbar from '../serp/Toolbar'
import Sidebar from '../serp/Sidebar'
import BottomToolbar from '../serp/BottomToolbar'
import Loader from '../serp/Loader'
import SelectedFilters from '../serp/SelectedFilters'

export default () => {
    const {
        response: { products },
        loading,
    } = useAppState()
    const foundProducts = products && products.total > 0
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768)
        }

        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])


    return (
        <div
            class="ns-serp ns-d-flex ns-flex-column ns-flex-md-column ns-font-inherit ns-my-0 container"
            data-nosto-element="search">
            {(foundProducts || (loading && foundProducts)) && (
                <Fragment>
                    {!isMobile && <Sidebar />}
                    <Toolbar mobile />
                </Fragment>
            )}
            <div
                class="ns-d-flex ns-flex-column ns-w-100 ns-border-box ns-p-0"
                style={loading ? 'position: relative;' : ''}>
                {foundProducts ? (
                    <>
                        {!isMobile && <SelectedFilters />}
                        <Toolbar />
                        <Products isMobile={isMobile} />
                        <BottomToolbar />
                    </>
                ) : (
                    <NoResults />
                )}
            </div>
        </div>
    )
}

// import { useAppState } from '@nosto/preact'

// import NoResults from '../serp/NoResults'
// import Products from '../serp/Products'
// import Toolbar from '../serp/Toolbar'
// import Sidebar from '../serp/Sidebar'
// import BottomToolbar from '../serp/BottomToolbar'
// import Loader from '../serp/Loader'
// import SelectedFilters from '../serp/SelectedFilters'
// import { useEffect } from 'preact/hooks'

// export default () => {
//     const { response: { products }, loading } = useAppState()
//     const foundProducts = products && products.total > 0

//     useEffect(()=>{
//         jQuery(".nosto-search-header, .breadcrumbs-wrapper").remove();
//     })

//     return (
//         <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-column ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto">
//             {foundProducts && <Fragment>
//                 <Sidebar />
//                 <Toolbar mobile />
//             </Fragment>
//             }
//             <div class="ns-d-block nosto-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0">
//                 {loading ? (
//                     <Loader />
//                 ) : foundProducts ? (
//                     <>
//                         {/* <SelectedFilters /> */}
//                         <Toolbar />
//                         <Products />
//                         <BottomToolbar />
//                     </>
//                 ) : (
//                     <NoResults />
//                 )}
//             </div>
//         </div>
//     )
// }
